import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { Banner, Layout, Page } from "@shopify/polaris"

export default function ExitIframe() {
  const { search } = useLocation()
  const [showWarning, setShowWarning] = useState(false)

  useEffect(() => {
    console.log("[ExitIframe] Component mounted, search:", search)

    if (search) {
      const params = new URLSearchParams(search)
      const redirectUri = params.get("redirectUri")
      console.log("[ExitIframe] redirectUri:", redirectUri)

      if (redirectUri) {
        const decodedUri = decodeURIComponent(redirectUri)
        console.log("[ExitIframe] decodedUri:", decodedUri)
        const url = new URL(decodedUri)
        console.log("[ExitIframe] url hostname:", url.hostname)
        console.log("[ExitIframe] location hostname:", location.hostname)

        if (
          [location.hostname, "admin.shopify.com"].includes(url.hostname) ||
          url.hostname.endsWith(".myshopify.com")
        ) {
          console.log("[ExitIframe] Redirecting to:", url.toString())
          window.open(url.toString(), "_top")
        } else {
          console.log("[ExitIframe] Invalid redirect, showing warning")
          setShowWarning(true)
        }
      }
    }
  }, [search])

  return showWarning ? (
    <Page narrowWidth>
      <Layout>
        <Layout.Section>
          <div style={{ marginTop: "100px" }}>
            <Banner title="Redirecting outside of Shopify" tone="warning">
              <p>
                Apps can only use /exitiframe to reach Shopify or the app
                itself.
              </p>
            </Banner>
          </div>
        </Layout.Section>
      </Layout>
    </Page>
  ) : null
}
